import React, { useState, useEffect, useRef } from "react";
import FindDrivers from "./FindDrivers";
import dzire from "../assets/cars/dzire.png";
import innova from "../assets/cars/innova.png";
import ertiga from "../assets/cars/ertiga.png";
import aura from "../assets/cars/aura.png";
import traveller from "../assets/cars/traveller.png";
import logo from "../assets/logo/tamworld_logo.png";
import dayjs from "dayjs";
import DestinationPage from "./DestinationPage";
import { FaWhatsapp } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import toast, { Toaster } from "react-hot-toast";
import SEO from "../components/SEO";

// ── Global CSS ────────────────────────────────────────────────────────────────
const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

  @keyframes fadeUp   { from{opacity:0;transform:translateY(28px)} to{opacity:1;transform:translateY(0)} }
  @keyframes pulse    { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.5;transform:scale(1.4)} }
  @keyframes marquee  { from{transform:translateX(0)} to{transform:translateX(-50%)} }
  @keyframes slideDown{ from{opacity:0;transform:translateY(-12px)} to{opacity:1;transform:translateY(0)} }
  @keyframes spin     { to{transform:rotate(360deg)} }
  @keyframes fadeIn   { from{opacity:0;transform:scale(.96)} to{opacity:1;transform:scale(1)} }
  @keyframes ring {
    0%{transform:rotate(0)} 10%{transform:rotate(10deg)} 20%{transform:rotate(-10deg)}
    30%{transform:rotate(8deg)} 40%{transform:rotate(-8deg)} 50%{transform:rotate(5deg)}
    60%{transform:rotate(-5deg)} 70%{transform:rotate(2deg)} 80%{transform:rotate(-2deg)}
    90%{transform:rotate(1deg)} 100%{transform:rotate(0)}
  }
  @keyframes stopFadeIn {
    from { opacity:0; transform:translateY(-8px); }
    to   { opacity:1; transform:translateY(0); }
  }

  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
  html  { scroll-behavior:smooth; }
  body  { font-family:'Plus Jakarta Sans',sans-serif; overflow-x:hidden; }

  .loader {
    width:50px; height:50px;
    border:5px solid #eee; border-top:5px solid #f5c518;
    border-radius:50%; animation:spin 1s linear infinite;
  }

  .fleet-scroll::-webkit-scrollbar { height:8px; }
  .fleet-scroll::-webkit-scrollbar-track { background:#eee; border-radius:10px; }
  .fleet-scroll::-webkit-scrollbar-thumb { background:linear-gradient(90deg,#f5c518,#d4a80f); border-radius:10px; }
  .fleet-scroll::-webkit-scrollbar-thumb:hover { background:#f5c518; }
  .fleet-scroll { scroll-behavior:auto !important; }

  .ringing { display:inline-flex; align-items:center; gap:6px; animation:ring 1s infinite; transform-origin:center; }

  .nav-link:hover       { color:#f5c518 !important; }
  .service-card:hover   { transform:translateY(-6px) !important; box-shadow:0 24px 60px rgba(0,0,0,.13) !important; }
  .why-card:hover       { background:#1a1a2e !important; }
  .why-card:hover .why-title { color:#f5c518 !important; }
  .why-card:hover .why-desc  { color:rgba(255,255,255,.65) !important; }
  .review-card:hover    { transform:translateY(-4px) !important; box-shadow:0 16px 40px rgba(0,0,0,.1) !important; }
  .dest-card:hover      { transform:translateY(-8px) scale(1.02) !important; box-shadow:0 25px 60px rgba(0,0,0,.18) !important; }
  .fleet-item:hover     { transform:translateY(-6px) !important; box-shadow:0 20px 50px rgba(0,0,0,.13) !important; }
  .scroll-top:hover     { transform:scale(1.1) !important; }
  .field-input:focus    { border-color:#f5c518 !important; box-shadow:0 0 0 4px rgba(245,197,24,.12) !important; }

  .stop-row { animation: stopFadeIn .2s ease; }

  .add-stop-btn:hover {
    border-color:#f5c518 !important;
    color:#b8860b !important;
    background:rgba(245,197,24,.06) !important;
  }

  @keyframes floatCar4 {
    0%  { transform: translateY(0px) rotate(-12deg); }
    50% { transform: translateY(-16px) rotate(-9deg); }
    100%{ transform: translateY(0px) rotate(-12deg); }
  }
  @keyframes floatCar5 {
    0%  { transform: translateY(0px) rotate(10deg); }
    50% { transform: translateY(14px) rotate(14deg); }
    100%{ transform: translateY(0px) rotate(10deg); }
  }
  @keyframes floatCar6 {
    0%  { transform: translateY(0px) rotate(-4deg); }
    50% { transform: translateY(-12px) rotate(-1deg); }
    100%{ transform: translateY(0px) rotate(-4deg); }
  }
  @keyframes floatCar7 {
    0%  { transform: translateY(0px) rotate(14deg); }
    50% { transform: translateY(10px) rotate(10deg); }
    100%{ transform: translateY(0px) rotate(14deg); }
  }

  /* ── Date Range Picker Modal ── */
  .drp-overlay {
    position:fixed; inset:0; background:rgba(0,0,0,.5);
    z-index:10000; display:flex; align-items:center; justify-content:center;
    padding:16px;
  }
  .drp-modal {
    background:#1a1a2e; border-radius:16px;
    box-shadow:0 32px 80px rgba(0,0,0,.45);
    overflow:hidden; animation:fadeIn .22s ease;
    width:100%; max-width:760px;
  }
  .drp-header {
    background:#111827; padding:14px 20px;
    display:flex; align-items:center; justify-content:space-between;
  }
  .drp-header-title { color:#fff; font-weight:700; font-size:15px; letter-spacing:.5px; }
  .drp-close {
    background:rgba(255,255,255,.1); border:none; color:#fff;
    width:30px; height:30px; border-radius:50%; cursor:pointer; font-size:16px;
    display:flex; align-items:center; justify-content:center;
  }
  .drp-dates-bar {
    background:#111827; padding:10px 20px 14px;
    display:flex; gap:32px; align-items:flex-end; border-bottom:1px solid rgba(255,255,255,.08);
  }
  .drp-date-block { display:flex; flex-direction:column; gap:2px; }
  .drp-date-label { font-size:11px; color:rgba(255,255,255,.45); letter-spacing:1px; text-transform:uppercase; }
  .drp-date-num   { font-size:38px; font-weight:900; line-height:1; color:#2563eb; }
  .drp-date-sub   { font-size:12px; color:#2563eb; }
  .drp-date-num.return  { color:#16a34a; }
  .drp-date-sub.return  { color:#16a34a; }
  .drp-badge {
    background:#374151; color:#fff; font-size:11px; font-weight:700;
    padding:3px 10px; border-radius:50px; margin:0 auto 4px;
  }
  .drp-underline { width:100%; height:2px; background:#2563eb; margin-top:2px; border-radius:2px; }
  .drp-underline.return { background:#16a34a; }
  .drp-calendars { display:flex; gap:0; padding:20px; overflow-x:auto; }
  .drp-modal::-webkit-scrollbar { width:6px; }
  .drp-modal::-webkit-scrollbar-thumb { background:rgba(255,255,255,.2); border-radius:10px; }
  .drp-cal { flex:1; min-width:280px; }
  .drp-cal + .drp-cal { padding-left:24px; border-left:1px solid rgba(255,255,255,.08); margin-left:24px; }
  .drp-cal-header { display:flex; align-items:center; justify-content:space-between; margin-bottom:14px; }
  .drp-cal-title { color:#fff; font-weight:700; font-size:15px; }
  .drp-nav-btn {
    background:rgba(255,255,255,.08); border:none; color:#fff;
    width:28px; height:28px; border-radius:8px; cursor:pointer; font-size:14px;
    display:flex; align-items:center; justify-content:center; transition:background .2s;
  }
  .drp-nav-btn:hover { background:rgba(255,255,255,.18); }
  .drp-week-row { display:grid; grid-template-columns:repeat(7,1fr); gap:2px; margin-bottom:6px; }
  .drp-week-day { text-align:center; font-size:11px; color:rgba(255,255,255,.35); font-weight:600; padding:4px 0; }
  .drp-days-grid { display:grid; grid-template-columns:repeat(7,1fr); gap:2px; }
  .drp-day {
    aspect-ratio:1; display:flex; align-items:center; justify-content:center;
    border-radius:8px; font-size:13px; font-weight:600; cursor:pointer;
    color:rgba(255,255,255,.75); transition:background .15s, color .15s;
    position:relative; border:none; background:transparent;
  }
  .drp-day:hover:not(.drp-day-disabled):not(.drp-day-selected) { background:rgba(245,197,24,.18); color:#f5c518; }
  .drp-day-disabled { color:rgba(255,255,255,.18); cursor:default; }
  .drp-day-empty    { cursor:default; }
  .drp-day-selected { background:#f5c518 !important; color:#1a1a2e !important; font-weight:800; }
  .drp-day-start    { border-radius:8px 0 0 8px; }
  .drp-day-end      { border-radius:0 8px 8px 0; }
  .drp-day-in-range { background:rgba(245,197,24,.15); color:#fff; border-radius:0; }
  .drp-day-start.drp-day-end { border-radius:8px; }
  .drp-footer {
    padding:14px 20px; background:#111827;
    display:flex; justify-content:flex-end; gap:10px;
    border-top:1px solid rgba(255,255,255,.08);
  }
  .drp-btn-cancel {
    background:rgba(255,255,255,.08); border:none; color:rgba(255,255,255,.7);
    padding:9px 22px; border-radius:50px; font-size:13px; font-weight:700; cursor:pointer;
    font-family:'Plus Jakarta Sans',sans-serif; transition:background .2s;
  }
  .drp-btn-cancel:hover { background:rgba(255,255,255,.15); }
  .drp-btn-apply {
    background:linear-gradient(135deg,#f5c518,#d4a80f); border:none; color:#1a1a2e;
    padding:9px 28px; border-radius:50px; font-size:13px; font-weight:800; cursor:pointer;
    font-family:'Plus Jakarta Sans',sans-serif; transition:opacity .2s;
  }
  .drp-btn-apply:hover { opacity:.9; }

  /* MOBILE FIX FOR ROUND TRIP MODAL */
  @media (max-width:768px) {
    .drp-overlay { padding:0 !important; align-items:flex-end !important; }
    .drp-modal { width:100% !important; max-width:100% !important; height:92vh !important; border-radius:22px 22px 0 0 !important; overflow-y:auto !important; overflow-x:hidden !important; }
    .drp-dates-bar { gap:14px !important; padding:12px 14px !important; }
    .drp-date-num { font-size:28px !important; }
    .drp-calendars { padding:14px !important; overflow-y:auto !important; }
    .drp-cal { min-width:100% !important; }
    .drp-footer { position:sticky; bottom:0; background:#111827; z-index:5; }
  }

  .mobile-menu {
    position:fixed; top:0; left:0; right:0; bottom:0;
    background:rgba(26,26,46,.97); z-index:999;
    display:flex; flex-direction:column; align-items:center; justify-content:center;
    gap:32px; animation:slideDown .25s ease;
  }
  .mobile-menu a { font-size:22px; font-weight:700; color:rgba(255,255,255,.85); text-decoration:none; transition:color .2s; }
  .mobile-menu a:hover { color:#f5c518; }

  @media (max-width:768px) {
    .hide-mobile  { display:none !important; }
    .show-mobile  { display:flex !important; }
    .hero-padding { padding:40px 16px 52px !important; }
    .section-pad  { padding:52px 16px !important; }
    .footer-grid  { grid-template-columns:1fr 1fr !important; gap:28px !important; }
    .cta-btn      { padding:14px 32px !important; font-size:15px !important; }
    .stats-grid   { grid-template-columns:1fr 1fr !important; gap:24px !important; }
    .toggle-btn   { padding:10px 20px !important; font-size:13px !important; }
    .why-grid     { grid-template-columns:1fr !important; }
    .hero-title   { font-size:clamp(38px,9vw,60px) !important; }
    .booking-card { border-radius:20px !important; padding:22px 16px !important; }
    .veh-grid-4   { grid-template-columns:repeat(2,1fr) !important; }
    .trust-grid   { grid-template-columns:1fr !important; }
    .drp-calendars { flex-direction:column; }
    .drp-cal + .drp-cal { padding-left:0; border-left:none; margin-left:0; padding-top:20px; border-top:1px solid rgba(255,255,255,.08); margin-top:16px; }
  }
  @media (max-width:480px) {
    .footer-grid  { grid-template-columns:1fr !important; }
    .dest-grid    { grid-template-columns:1fr 1fr !important; }
  }
  @media (min-width:769px) {
    .show-mobile  { display:none !important; }
    .hide-mobile  { display:flex !important; }
  }
`;

const C = {
  bg:"#f8f9fd", dark:"#1a1a2e", gold:"#f5c518", goldD:"#d4a80f",
  gray:"#6b7280", grayL:"#9ca3af", border:"#e5e7eb", white:"#ffffff",
};
const F = { display:"'Playfair Display', serif", body:"'Plus Jakarta Sans', sans-serif" };

// ── Data ─────────────────────────────────────────────────────────────────────
const VEHICLES = [
  { id:"hatchback", img:require("../assets/cars/1.png"),  label:"Hatchback"    },
  { id:"sedan",     img:require("../assets/cars/2.png"),  label:"Sedan"        },
  { id:"suv",       img:require("../assets/cars/3.png"),  label:"SUV"          },
  { id:"premium_suv", img:require("../assets/cars/4.png"),label:"Premium SUV"  },
];
const DESTINATIONS = [
  { name:"Bhavnath",  img: require("../assets/dest/Bhavnath.jpg")  },
  { name:"SasanGir",  img: require("../assets/dest/SasanGir.jpg")  },
  { name:"Somanath",  img: require("../assets/dest/Somanath.jpg")  },
  { name:"Dwarka",    img: require("../assets/dest/Dwarka.jpg")    },
  { name:"Porbandar", img: require("../assets/dest/porbandar.jpg") },
  { name:"Diu",       img: require("../assets/dest/diu.jpg")       },
];
const STATS = [
  { num:"98%",  label:"Happy Clients"    },
  { num:"7K+",  label:"Customers Served" },
  { num:"5+",   label:"Years Experience" },
];
const WHY_US = [
  { icon:"🚖", title:"Verified Drivers",      desc:"All drivers are background-checked and trained to ensure safe, reliable, and comfortable rides every time."                        },
  { icon:"🛡️", title:"Your Safety First",     desc:"Background-checked drivers, real-time tracking, and an unwavering commitment to your security on every journey."                 },
  { icon:"📞", title:"24×7 Support",          desc:"Always here for you. Round-the-clock assistance for all your questions, concerns, and last-minute changes."                       },
  { icon:"⭐", title:"Top Rated Drivers",      desc:"Highly rated, professional, and courteous drivers who treat every ride as an opportunity to exceed expectations."                 },
  { icon:"💎", title:"Excellence in Service", desc:"Skilled drivers, exceptional service, and policies designed to address concerns and leave you fully satisfied."                    },
];
const FLEET = [
  { img:require("../assets/cars/1.png"),            name:"Swift Wegoner",   seats:"4 Seats",  type:"Hatchback"   },
  { img:require("../assets/cars/2.png"),            name:"Swift Dzire",     seats:"4 Seats",  type:"Sedan"       },
  { img:require("../assets/cars/3.png"),            name:"Maruti Ertiga",   seats:"7 Seats",  type:"SUV"         },
  { img:require("../assets/cars/4.png"),            name:"Crysta",          seats:"7 Seats",  type:"Premium SUV" },
  { img:require("../assets/cars/traveller.png"),    name:"Tempo Traveller", seats:"14 Seats", type:"Van"         },
];
const REVIEWS = [
  { name:"Sanjay Singh",    rating:5, text:"हमारी यात्रा बहुत आरामदायक रही। टैक्सी सर्विस बहुत अच्छी है और ड्राइवर का व्यवहार बहुत ही अच्छा था।"         },
  { name:"Dr. Nitin Gupta", rating:5, text:"Excellent service with punctuality. Well maintained car and professional driver. Best for outstation travel."        },
  { name:"Akhil Shreya",    rating:5, text:"Thank you for the most comfortable journey I have ever had. Truly world-class experience! 🤝"                       },
  { name:"Krati Gaur",      rating:5, text:"Took a cab for airport transfer — the best experience ever. Great rates compared to other vendors, highly recommend!"},
  { name:"Anindita",        rating:5, text:"It was a nice and comfortable journey. The driver was on time and very courteous. Thanks HaloSorath!"                },
  { name:"Vinod Raghav",    rating:5, text:"Best taxi service provider! Very professional drivers and owner is very generous. Highly recommend. 👍"               },
];
const FAQS = [
  { q:"How can I book a cab?",                       a:"You can call us directly, WhatsApp us, or simply click 'Find Cabs Now' on our website. We're available 24×7 to assist you."                        },
  { q:"How do I pay for the cab?",                   a:"We accept cash, credit/debit card, UPI, and mobile payments. Check with the driver before the trip to confirm accepted methods."                    },
  { q:"Does the fare include tolls & parking?",      a:"Yes! The fare includes all airport entry, toll, and parking charges. We strictly advise against paying anything extra to the driver."                },
  { q:"Can I change my booking after confirmation?", a:"Absolutely! Contact us directly to update your booking details. We'll work with you to make any necessary adjustments hassle-free."                  },
  { q:"Is there a cancellation fee?",                a:"No cancellation fees! Our zero-cancellation policy lets you change plans without any stress or extra charges. Book with peace of mind."              },
];
const MARQUEE_ITEMS = ["✈ Airport Transfers","🗺 Outstation Cabs","🏢 Corporate Rentals","🚉 Railway Transfers","👑 Luxury Rides","⭐ Top Rated Drivers"];

const pad     = (n) => String(n).padStart(2, "0");
const fmtDate = (d) => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
const NOW     = fmtDate(new Date());

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const DAYS   = ["S","M","T","W","T","F","S"];

// ── Date Range Picker ─────────────────────────────────────────────────────────
function DateRangePicker({ startDate, endDate, onApply, onClose }) {
  const today    = dayjs().startOf("day");
  const initStart = startDate ? dayjs(startDate) : today;
  const initEnd   = endDate   ? dayjs(endDate)   : null;

  const [selecting, setSelecting] = useState("start");
  const [hoverDate, setHoverDate] = useState(null);
  const [selStart,  setSelStart]  = useState(initStart);
  const [selEnd,    setSelEnd]    = useState(initEnd);
  const [viewYear,  setViewYear]  = useState(initStart.year());
  const [viewMonth, setViewMonth] = useState(initStart.month());

  const cal2 = dayjs(new Date(viewYear, viewMonth + 1, 1));

  const prevMonth = () => { const d = dayjs(new Date(viewYear, viewMonth - 1, 1)); setViewYear(d.year()); setViewMonth(d.month()); };
  const nextMonth = () => { const d = dayjs(new Date(viewYear, viewMonth + 1, 1)); setViewYear(d.year()); setViewMonth(d.month()); };

  const handleDayClick = (d) => {
    if (d.isBefore(today)) return;
    if (!selStart || selecting === "start") {
      setSelStart(d); setSelEnd(null); setSelecting("end"); return;
    }
    if (selecting === "end") {
      if (d.isBefore(selStart)) { setSelStart(d); setSelEnd(null); setSelecting("end"); }
      else { setSelEnd(d); setSelecting(null); }
      return;
    }
    setSelStart(d); setSelEnd(null); setSelecting("end");
  };

  const isInRange = (d) => {
    const rangeEnd = selEnd || hoverDate;
    if (!selStart || !rangeEnd) return false;
    return d.isAfter(selStart) && d.isBefore(rangeEnd);
  };

  const dayDiff = selStart && selEnd ? selEnd.diff(selStart, "day") : null;

  function buildCalDays(year, month) {
    const first = dayjs(new Date(year, month, 1));
    const startDow = first.day();
    const daysInMonth = first.daysInMonth();
    const cells = [];
    for (let i = 0; i < startDow; i++) cells.push(null);
    for (let d = 1; d <= daysInMonth; d++) cells.push(dayjs(new Date(year, month, d)));
    return cells;
  }

  function CalGrid({ year, month }) {
    const cells = buildCalDays(year, month);
    return (
      <div className="drp-days-grid">
        {cells.map((d, i) => {
          if (!d) return <div key={i} className="drp-day drp-day-empty" />;
          const isDisabled = d.isBefore(today);
          const isStart    = selStart && d.isSame(selStart, "day");
          const isEnd      = selEnd   && d.isSame(selEnd,   "day");
          const inRange    = isInRange(d);
          let cls = "drp-day";
          if (isDisabled) cls += " drp-day-disabled";
          if (isStart) cls += " drp-day-selected drp-day-start";
          if (isEnd)   cls += " drp-day-selected drp-day-end";
          if (inRange && !isStart && !isEnd) cls += " drp-day-in-range";
          return (
            <button key={i} className={cls}
              onClick={() => !isDisabled && handleDayClick(d)}
              onMouseEnter={() => { if (selecting === "end") setHoverDate(d); }}
              onMouseLeave={() => setHoverDate(null)}>
              {d.date()}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="drp-overlay" onClick={onClose}>
      <div className="drp-modal" onClick={e => e.stopPropagation()}>
        <div className="drp-header">
          <span className="drp-header-title">Round Trip</span>
          <button className="drp-close" onClick={onClose}>✕</button>
        </div>

        <div className="drp-dates-bar">
          <div className="drp-date-block">
            <span className="drp-date-label">Departure</span>
            <div style={{display:"flex",alignItems:"flex-end",gap:8}}>
              <span className="drp-date-num">{selStart ? selStart.date() : "--"}</span>
              <div>
                <div className="drp-date-sub">{selStart ? selStart.format("MMM-YYYY") : ""}</div>
                <div style={{fontSize:12,color:"rgba(255,255,255,.35)"}}>{selStart ? selStart.format("hh:mm A") : ""}</div>
              </div>
            </div>
            <div className="drp-underline" />
          </div>

          {dayDiff !== null && (
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",marginBottom:4}}>
              <span className="drp-badge">{dayDiff} DAYS</span>
            </div>
          )}

          <div className="drp-date-block" style={{marginLeft:"auto"}}>
            <span className="drp-date-label" style={{textAlign:"right",display:"block",color:"#16a34a"}}>Return</span>
            <div style={{display:"flex",alignItems:"flex-end",gap:8}}>
              <span className="drp-date-num return">{selEnd ? selEnd.date() : "--"}</span>
              <div>
                <div className="drp-date-sub return">{selEnd ? selEnd.format("MMM-YYYY") : ""}</div>
                <div style={{fontSize:12,color:"rgba(255,255,255,.35)"}}>{selEnd ? "11:59 PM" : ""}</div>
              </div>
            </div>
            <div className="drp-underline return" />
          </div>
        </div>

        <div className="drp-calendars">
          <div className="drp-cal">
            <div className="drp-cal-header">
              <button className="drp-nav-btn" onClick={prevMonth}>‹</button>
              <span className="drp-cal-title">{MONTHS[viewMonth]} {viewYear}</span>
              <button className="drp-nav-btn" onClick={nextMonth}>›</button>
            </div>
            <div className="drp-week-row">
              {DAYS.map((d,i) => <div key={i} className="drp-week-day">{d}</div>)}
            </div>
            <CalGrid year={viewYear} month={viewMonth} />
          </div>

          <div className="drp-cal">
            <div className="drp-cal-header">
              <button className="drp-nav-btn" onClick={prevMonth}>‹</button>
              <span className="drp-cal-title">{MONTHS[cal2.month()]} {cal2.year()}</span>
              <button className="drp-nav-btn" onClick={nextMonth}>›</button>
            </div>
            <div className="drp-week-row">
              {DAYS.map((d,i) => <div key={i} className="drp-week-day">{d}</div>)}
            </div>
            <CalGrid year={cal2.year()} month={cal2.month()} />
          </div>
        </div>

        <div className="drp-footer">
          <button className="drp-btn-cancel" onClick={onClose}>Cancel</button>
          <button className="drp-btn-apply"
            onClick={() => {
              if (!selStart || !selEnd) { toast.error("Please select both departure and return dates"); return; }
              onApply(selStart.format("YYYY-MM-DD"), selEnd.format("YYYY-MM-DD"));
            }}>
            Apply Dates
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Shared Components ─────────────────────────────────────────────────────────
function Section({ id, bg = C.bg, children, style = {} }) {
  return (
    <section id={id} className="section-pad" style={{ background:bg, padding:"80px 24px", ...style }}>
      <div style={{ maxWidth:1100, margin:"0 auto" }}>{children}</div>
    </section>
  );
}

function SectionHeading({ eyebrow, title, sub, light }) {
  return (
    <div style={{ textAlign:"center", marginBottom:48 }}>
      {eyebrow && <p style={{ fontSize:11, letterSpacing:"2.5px", textTransform:"uppercase", fontWeight:700, color:C.goldD, marginBottom:10 }}>{eyebrow}</p>}
      <h2 style={{ fontFamily:F.display, fontSize:"clamp(24px,4vw,42px)", fontWeight:800, color:light?C.white:C.dark, lineHeight:1.15, marginBottom:sub?14:0 }}>{title}</h2>
      {sub && <p style={{ fontSize:"clamp(13px,1.7vw,16px)", color:light?"rgba(255,255,255,.6)":C.grayL, maxWidth:520, margin:"0 auto", padding:"0 16px" }}>{sub}</p>}
    </div>
  );
}

const Field = React.forwardRef((props, ref) => {
  const { label, icon, type="text", placeholder, value, onChange, disabled, onClear, min, error, readOnly, onClick } = props;
  const inputRef = useRef(null);
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
      <label style={{ fontSize:12, fontWeight:700, color:C.gray, letterSpacing:"1px", textTransform:"uppercase", marginLeft:4 }}>{label}</label>
      <div style={{ position:"relative", cursor: readOnly ? "pointer" : "text" }}
        onClick={() => { if(type==="datetime-local"){inputRef.current?.showPicker?.();inputRef.current?.focus();} if(onClick) onClick(); }}>
        <span style={{ position:"absolute", left:14, top:"50%", transform:"translateY(-50%)", fontSize:18 }}>{icon}</span>
        <input
          ref={(el) => { inputRef.current=el; if(ref) ref.current=el; }}
          type={type} min={min} placeholder={placeholder} value={value}
          onChange={onChange} disabled={disabled} className="field-input" readOnly={readOnly}
          style={{ width:"100%", background:C.white, color:"#1a1a1a", border: error ? "1.5px solid red" : `1.5px solid ${C.border}`, borderRadius:14, padding:"16px 40px 16px 46px", fontSize:15, outline:"none", fontFamily:F.body, cursor: readOnly ? "pointer" : "text" }}
        />
        {onClear && value && (
          <button onClick={(e)=>{e.stopPropagation();onClear();}} style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer" }}>✕</button>
        )}
      </div>
    </div>
  );
});

// ── Main Component ────────────────────────────────────────────────────────────
export default function Home() {
  const [tripType,       setTripType]      = useState("one");
  const [pickup,         setPickup]        = useState("");
  const [destination,    setDestination]   = useState("");
  const [startDate,      setStartDate]     = useState(dayjs().format("YYYY-MM-DD"));
  const [endDate,        setEndDate]       = useState("");
  const [activeVeh,      setActiveVeh]     = useState("");
  const [openFaq,        setOpenFaq]       = useState(null);
  const [showDrivers,    setShowDrivers]   = useState(false);
  const [showScroll,     setShowScroll]    = useState(false);
  const [menuOpen,       setMenuOpen]      = useState(false);
  const [cabsData,       setCabsData]      = useState([]);
  const [loading,        setLoading]       = useState(false);
  const [error,          setError]         = useState(false);
  const [showDatePicker, setShowDatePicker]= useState(false);

  // ── Via Stops State ──────────────────────────────────────────────────────
  // Each stop: { id: number, value: string }
  const [stops, setStops] = useState([]);
  const stopRefs = useRef({}); // keyed by stop.id → DOM input element

  const navigate = useNavigate();

  const fleetRef       = useRef(null);
  const reviewRef      = useRef(null);
  const pickupRef      = useRef(null);
  const destinationRef = useRef(null);

  const doubled = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  const [pauseFleet,  setPauseFleet]  = useState(false);
  const [pauseReview, setPauseReview] = useState(false);

  // ── Stop helpers ─────────────────────────────────────────────────────────
  const addStop = () => {
    if (stops.length >= 5) return;
    setStops(prev => [...prev, { id: Date.now(), value: "" }]);
  };

  const removeStop = (id) => {
    setStops(prev => prev.filter(s => s.id !== id));
    delete stopRefs.current[id];
  };

  const updateStop = (id, value) => {
    setStops(prev => prev.map(s => s.id === id ? { ...s, value } : s));
  };

  // ── Google Places Autocomplete — pickup & destination ────────────────────
  useEffect(() => {
  const initializeAutocomplete = () => {
    if (
      !window.google ||
      !pickupRef.current ||
      !destinationRef.current
    ) {
      setTimeout(initializeAutocomplete, 500);
      return;
    }

    const pickupAuto =
      new window.google.maps.places.Autocomplete(
        pickupRef.current,
        {
          types: ["geocode"],
          componentRestrictions: { country: "in" },
        }
      );

    const destAuto =
      new window.google.maps.places.Autocomplete(
        destinationRef.current,
        {
          types: ["geocode"],
          componentRestrictions: { country: "in" },
        }
      );

    pickupAuto.addListener("place_changed", () => {
      const place = pickupAuto.getPlace();
      setPickup(place.formatted_address || "");
    });

    destAuto.addListener("place_changed", () => {
      const place = destAuto.getPlace();
      setDestination(place.formatted_address || "");
    });
  };

  initializeAutocomplete();
}, []);

  // ── Google Places Autocomplete — via stops ───────────────────────────────
  useEffect(() => {
    if (!window.google) return;
    stops.forEach(stop => {
      const inputEl = stopRefs.current[stop.id];
      if (!inputEl || inputEl._acAttached) return;
      const ac = new window.google.maps.places.Autocomplete(inputEl, {
        types: ["geocode"],
        componentRestrictions: { country: "in" },
      });
      ac.addListener("place_changed", () => {
        const p = ac.getPlace();
        updateStop(stop.id, p.formatted_address || "");
      });
      inputEl._acAttached = true;
    });
  }, [stops]);

  // ── Fleet auto-scroll ────────────────────────────────────────────────────
  useEffect(() => {
    const el = fleetRef.current;
    if (!el) return;
    const interval = setInterval(() => {
      if (!pauseFleet) {
        el.scrollLeft += 1;
        if (el.scrollLeft >= el.scrollWidth / 2) el.scrollLeft -= el.scrollWidth / 2;
      }
    }, 20);
    return () => clearInterval(interval);
  }, [pauseFleet]);

  // ── Reviews auto-scroll ──────────────────────────────────────────────────
  useEffect(() => {
    const el = reviewRef.current;
    if (!el) return;
    const interval = setInterval(() => {
      if (!pauseReview) {
        el.scrollLeft += 1;
        if (el.scrollLeft >= el.scrollWidth / 2) el.scrollLeft -= el.scrollWidth / 2;
      }
    }, 20);
    return () => clearInterval(interval);
  }, [pauseReview]);

  useEffect(() => {
    const onScroll = () => setShowScroll(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = (menuOpen || showDatePicker) ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen, showDatePicker]);

  const vehicleMap = { sedan:"Sedan", suv:"SUV", innova:"Innova", hatchback:"Hatchback", premium_suv:"Premium SUV" };

  // ── Find Cabs ────────────────────────────────────────────────────────────
  const handleFindCabs = async () => {
    if (!pickup) {
      setError(true);
      pickupRef.current?.focus();
      return;
    }
    if (!destination) {
      setError(true);
      destinationRef.current?.focus();
      return;
    }
    if (tripType === "round" && !endDate) {
      toast.error("Please select a return date for Round Trip");
      setShowDatePicker(true);
      return;
    }
    setError(false);

    // Build the via_cities string from stops (filter out empty ones)
    const viaCities = stops.map(s => s.value.trim()).filter(Boolean);

    try {
      setLoading(true);
      setCabsData([]);
      const res = await axios.get(
        "https://prashantbha.pythonanywhere.com/api/find-cabs/",
        {
          params: {
            pickup,
            drop: destination,
            vehicle_type: vehicleMap[activeVeh],
            trip_type: tripType,
            date: startDate,
            ...(tripType === "round" && endDate ? { return_date: endDate } : {}),
  ...(viaCities.length
    ? { via_cities: viaCities.join("|") }
    : {}),
          },
        }
      );
      const cabList = res.data.cabs || res.data || [];
      if (!cabList.length) { toast.error("No cabs available"); return; }
      setCabsData(cabList);
      navigate("/find-drivers", {
        state: {
          trip: {
            pickup,
            destination,
            stops: viaCities,        // pass stops array to FindDrivers
            startDate,
            endDate,
            vehicle: vehicleMap[activeVeh],
            tripType,
          },
          cabsData: cabList,
        },
      });
      setShowDrivers(true);
    } catch (err) {
      console.error("API ERROR:", err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const startDateDisplay = startDate ? dayjs(startDate).format("DD MMM YYYY") : "";
  const endDateDisplay   = endDate   ? dayjs(endDate).format("DD MMM YYYY")   : "";

  const NAV_LINKS = ["Home","Services","How It Works","For Cabs","Contact"];

  return (
    <>
      <SEO page="home" />
      <Toaster
        position="top-right"
        toastOptions={{
          style: { borderRadius:"14px", background:"#1a1a2e", color:"#f5c518", fontWeight:"600" },
        }}
      />
      <style>{GLOBAL_CSS}</style>

      {/* Loading overlay */}
      {loading && (
        <div style={{ position:"fixed", inset:0, background:"rgba(255,255,255,0.75)", backdropFilter:"blur(4px)", zIndex:9999, display:"flex", justifyContent:"center", alignItems:"center", flexDirection:"column" }}>
          <div className="loader" />
          <p style={{ marginTop:12, fontWeight:600, color:C.dark }}>Finding best cabs...</p>
        </div>
      )}

      {/* Date Range Picker Modal */}
      {showDatePicker && (
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          onClose={() => setShowDatePicker(false)}
          onApply={(s, e) => {
            setStartDate(s);
            setEndDate(e);
            setShowDatePicker(false);
          }}
        />
      )}

      <div style={{ fontFamily:F.body, background:C.bg, color:C.dark, overflowX:"hidden" }}>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="mobile-menu" onClick={() => setMenuOpen(false)}>
            <button onClick={() => setMenuOpen(false)} style={{ position:"absolute", top:20, right:20, background:"rgba(255,255,255,.1)", border:"none", color:"#fff", fontSize:22, width:44, height:44, borderRadius:"50%", cursor:"pointer" }}>✕</button>
            {NAV_LINKS.map(l => <a key={l} href="#" onClick={() => setMenuOpen(false)}>{l}</a>)}
            <a href="tel:+919265407669" style={{ fontSize:16, color:C.gold, fontWeight:600, textDecoration:"none" }}>📞 +91 92654 07669</a>
            <button style={{ background:`linear-gradient(135deg,${C.gold},${C.goldD})`, color:C.dark, border:"none", borderRadius:50, padding:"13px 36px", fontSize:15, fontWeight:800, fontFamily:F.body, cursor:"pointer" }}>List Your Cab</button>
          </div>
        )}

        {/* Navbar */}
        <Header defaultActive="Home" />

        {/* ── Hero ──────────────────────────────────────────────────────────── */}
        <div
          className="hero-padding"
          style={{
            position:"relative", overflow:"hidden",
            background:"linear-gradient(135deg,#fffdf5 0%,#f8f9fd 35%,#fff7d6 100%)",
            padding:"70px 20px 90px",
          }}
        >
          {/* Background glows */}
          <div style={{ position:"absolute", top:-120, right:-120, width:420, height:420, borderRadius:"50%", background:"rgba(245,197,24,.12)", filter:"blur(40px)", zIndex:0 }} />
          <div style={{ position:"absolute", bottom:-100, left:-100, width:300, height:300, borderRadius:"50%", background:"rgba(26,26,46,.08)", filter:"blur(35px)", zIndex:0 }} />

          {/* Background cars */}
          <div style={{ position:"absolute", inset:0, overflow:"hidden", zIndex:0, pointerEvents:"none" }}>
            <img src={require("../assets/cars/4.png")} alt="Premium SUV" style={{ position:"absolute", left:"-140px", bottom:"20px", width:"450px", opacity:0.13, transform:"rotate(-8deg)", animation:"floatCar 6s ease-in-out infinite", filter:"drop-shadow(0 20px 40px rgba(0,0,0,.08))" }} />
            <img src={require("../assets/cars/2.png")} alt="Sedan"       style={{ position:"absolute", right:"-120px", top:"70px", width:"380px", opacity:0.11, transform:"rotate(6deg)", animation:"floatCar2 7s ease-in-out infinite" }} />
            <img src={require("../assets/cars/1.png")} alt="Taxi"        style={{ position:"absolute", bottom:"-10px", left:"50%", transform:"translateX(-50%)", width:"320px", opacity:0.07, animation:"floatCar3 8s ease-in-out infinite" }} />
            <img src={require("../assets/cars/3.png")} alt="SUV"         style={{ position:"absolute", top:"40px", left:"8%", width:"180px", opacity:0.08, transform:"rotate(-12deg)", animation:"floatCar4 9s ease-in-out infinite" }} />
            <img src={require("../assets/cars/1.png")} alt="Cab"         style={{ position:"absolute", top:"30%", right:"12%", width:"160px", opacity:0.06, transform:"rotate(10deg)", animation:"floatCar5 10s ease-in-out infinite" }} />
            <img src={require("../assets/cars/3.png")} alt="SUV"         style={{ position:"absolute", bottom:"20px", right:"15%", width:"220px", opacity:0.08, transform:"rotate(-4deg)", animation:"floatCar6 8s ease-in-out infinite" }} />
            <img src={require("../assets/cars/2.png")} alt="Sedan"       style={{ position:"absolute", top:"45%", left:"-40px", width:"220px", opacity:0.07, transform:"rotate(14deg)", animation:"floatCar7 11s ease-in-out infinite" }} />
            <div style={{ position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:550, height:550, borderRadius:"50%", background:"rgba(245,197,24,.12)", filter:"blur(90px)" }} />
          </div>

          {/* Main content grid */}
          <div style={{ maxWidth:1200, margin:"0 auto", position:"relative", zIndex:2, display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(320px,1fr))", gap:50, alignItems:"center" }}>

            {/* LEFT CONTENT */}
            <div>
              {/* Badge */}
              <div style={{ display:"inline-flex", alignItems:"center", gap:10, background:"rgba(245,197,24,.12)", border:"1px solid rgba(245,197,24,.25)", padding:"8px 18px", borderRadius:999, marginBottom:24, backdropFilter:"blur(10px)" }}>
                <span style={{ width:8, height:8, borderRadius:"50%", background:"#f5c518", animation:"pulse 1.8s infinite" }} />
                <span style={{ fontSize:12, fontWeight:800, letterSpacing:1, color:"#b8860b", textTransform:"uppercase" }}>
                  Reliable Cab Service in Saurashtra – Halo Sorath
                </span>
              </div>

              {/* Heading */}
              <h1 className="hero-title" style={{ fontFamily:F.display, fontSize:"clamp(42px,8vw,78px)", lineHeight:1.02, fontWeight:900, color:C.dark, marginBottom:20, letterSpacing:"-2px" }}>
                Travel Gujarat <br />
                <span style={{ color:C.goldD }}>Comfortably & Safely</span>
              </h1>

              {/* Description */}
              <p style={{ fontSize:"clamp(15px,2vw,18px)", lineHeight:1.9, color:C.gray, maxWidth:560, marginBottom:30 }}>
                Book local taxi, airport transfer, outstation cab, Gir Somnath tour, Dwarka trip, and Gujarat travel packages with professional drivers and affordable pricing.
              </p>

              {/* Stats */}
              <div style={{ display:"flex", flexWrap:"wrap", gap:20, marginBottom:36 }}>
                {[["7K+","Happy Riders"],["24×7","Support"],["100%","Safe Travel"]].map(([num,text],i) => (
                  <div key={i} style={{ background:"rgba(255,255,255,.75)", backdropFilter:"blur(12px)", border:`1px solid ${C.border}`, borderRadius:18, padding:"16px 22px", minWidth:120, boxShadow:"0 10px 30px rgba(0,0,0,.05)" }}>
                    <div style={{ fontSize:24, fontWeight:900, color:C.dark, marginBottom:4 }}>{num}</div>
                    <div style={{ fontSize:12, color:C.grayL, fontWeight:700, letterSpacing:1, textTransform:"uppercase" }}>{text}</div>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <div style={{ display:"flex", flexWrap:"wrap", gap:16 }}>
                <button onClick={handleFindCabs} style={{ background:`linear-gradient(135deg,${C.gold},${C.goldD})`, color:C.dark, border:"none", borderRadius:999, padding:"18px 34px", fontSize:17, fontWeight:800, cursor:"pointer", boxShadow:"0 14px 40px rgba(245,197,24,.35)", transition:".3s" }}>
                  🔍 Find Cabs
                </button>
                <a href="tel:+919265407669" style={{ background:"#fff", color:C.dark, border:`1px solid ${C.border}`, borderRadius:999, padding:"18px 28px", fontSize:16, fontWeight:700, textDecoration:"none", display:"flex", alignItems:"center", gap:10, boxShadow:"0 10px 30px rgba(0,0,0,.05)" }}>
                  📞 Call Now
                </a>
              </div>
            </div>

            {/* ── BOOKING CARD ──────────────────────────────────────────────── */}
            <div className="booking-card" style={{ background:"rgba(255,255,255,.78)", backdropFilter:"blur(16px)", border:"1px solid rgba(255,255,255,.6)", borderRadius:32, padding:"34px 28px", boxShadow:"0 25px 70px rgba(0,0,0,.12)" }}>

              {/* Card title */}
              <div style={{ textAlign:"center", marginBottom:24 }}>
                <h2 style={{ fontFamily:F.display, fontSize:32, fontWeight:800, marginBottom:8, color:C.dark }}>Book Your Ride</h2>
                <p style={{ color:C.grayL, fontSize:14 }}>Quick booking in just a few seconds</p>
              </div>

              {/* Trip Type Toggle */}
              <div style={{ display:"flex", background:"#f3f4f6", padding:5, borderRadius:999, marginBottom:24 }}>
                {[["one","Outstation"],["round","Round Trip"]].map(([val,label]) => (
                  <button
                    key={val}
                    onClick={() => {
                      setTripType(val);
                      if (val === "one") { setStops([]); stopRefs.current = {}; }
                      if (val === "round" && !endDate) setShowDatePicker(true);
                    }}
                    style={{ flex:1, border:"none", borderRadius:999, padding:"14px 10px", cursor:"pointer", fontWeight:700, fontSize:14, transition:".3s", background:tripType===val?C.dark:"transparent", color:tripType===val?C.gold:C.gray }}
                  >
                    {label}
                  </button>
                ))}
              </div>

              {/* Fields */}
              <div style={{ display:"grid", gap:16, marginBottom:22 }}>

                {/* Pickup */}
                <Field
                  ref={pickupRef}
                  label="Pickup Location"
                  icon="📍"
                  placeholder="Enter pickup"
                  value={pickup}
                  onChange={(e) => setPickup(e.target.value)}
                />

                {/* Destination */}
                <Field
                  ref={destinationRef}
                  label="Destination"
                  icon="🏁"
                  placeholder="Enter destination"
                  value={destination}
                  onChange={(e) => setDestination(e.target.value)}
                />

                {/* ── Via Stops (Round Trip only) ── */}
                {tripType === "round" && (
                  <div>
                    {/* Stops label */}
                    {stops.length > 0 && (
                      <div style={{ fontSize:11, fontWeight:700, color:C.gray, letterSpacing:"1px", textTransform:"uppercase", marginBottom:10, marginLeft:4 }}>
                        Via Cities
                      </div>
                    )}

                    {stops.map((stop, idx) => (
                      <div
                        key={stop.id}
                        className="stop-row"
                        style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10 }}
                      >
                        {/* Connector dot */}
                        <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:2, flexShrink:0 }}>
                          <div style={{ width:8, height:8, borderRadius:"50%", background:C.gold, border:`2px solid ${C.goldD}` }} />
                        </div>

                        {/* Input */}
                        <div style={{ position:"relative", flex:1 }}>
                          <span style={{ position:"absolute", left:14, top:"50%", transform:"translateY(-50%)", fontSize:16 }}>🔶</span>
                          <input
                            ref={(el) => { if (el) stopRefs.current[stop.id] = el; }}
                            type="text"
                            placeholder={`Via city ${idx + 1} (e.g. Rajkot)`}
                            value={stop.value}
                            onChange={(e) => updateStop(stop.id, e.target.value)}
                            className="field-input"
                            style={{
                              width:"100%",
                              background:C.white,
                              color:"#1a1a1a",
                              border:`1.5px solid ${C.gold}44`,
                              borderRadius:14,
                              padding:"13px 40px 13px 42px",
                              fontSize:14,
                              outline:"none",
                              fontFamily:F.body,
                            }}
                          />
                        </div>

                        {/* Remove button */}
                        <button
                          onClick={() => removeStop(stop.id)}
                          title="Remove this stop"
                          style={{
                            width:32, height:32, borderRadius:"50%",
                            border:`1px solid ${C.border}`,
                            background:"#fff",
                            cursor:"pointer", fontSize:14,
                            display:"flex", alignItems:"center", justifyContent:"center",
                            color:C.gray, flexShrink:0,
                            transition:"all .2s",
                          }}
                          onMouseEnter={e => { e.currentTarget.style.background="#fee2e2"; e.currentTarget.style.color="#dc2626"; e.currentTarget.style.borderColor="#fca5a5"; }}
                          onMouseLeave={e => { e.currentTarget.style.background="#fff"; e.currentTarget.style.color=C.gray; e.currentTarget.style.borderColor=C.border; }}
                        >
                          ✕
                        </button>
                      </div>
                    ))}

                    {/* Add Stop Button */}
                    {stops.length < 5 && (
                      <button
                        onClick={addStop}
                        className="add-stop-btn"
                        style={{
                          width:"100%",
                          border:`1.5px dashed ${C.border}`,
                          borderRadius:14,
                          background:"transparent",
                          cursor:"pointer",
                          padding:"11px 14px",
                          fontSize:13,
                          color:C.gray,
                          display:"flex",
                          alignItems:"center",
                          gap:8,
                          marginBottom:4,
                          fontFamily:F.body,
                          fontWeight:600,
                          transition:"all .2s",
                        }}
                      >
                        <span style={{ fontSize:18, lineHeight:1, color:C.goldD }}>＋</span>
                        Add via city {stops.length > 0 ? `(${stops.length}/5)` : ""}
                      </button>
                    )}

                    {/* Max stops notice */}
                    {stops.length >= 5 && (
                      <p style={{ fontSize:12, color:C.grayL, textAlign:"center", marginBottom:4 }}>
                        Maximum 5 via cities added
                      </p>
                    )}
                  </div>
                )}

                {/* Date field */}
                {tripType === "one" ? (
                  <Field
                    label="Travel Date"
                    icon="📅"
                    type="date"
                    value={startDate}
                    min={dayjs().format("YYYY-MM-DD")}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                ) : (
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{ border:`1.5px solid ${C.border}`, borderRadius:16, padding:"18px 16px", background:"#fff", cursor:"pointer" }}
                  >
                    <div style={{ fontSize:12, fontWeight:700, color:C.gray, marginBottom:8, letterSpacing:1 }}>TRAVEL DATES</div>
                    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:12 }}>
                      <span style={{ fontWeight:600 }}>
                        {startDateDisplay} → {endDateDisplay || "Select"}
                      </span>
                      <span style={{ fontSize:20 }}>📅</span>
                    </div>
                  </div>
                )}
              </div>

              {/* Vehicle Selector */}
              <div className="veh-grid-4" style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:14, marginBottom:26 }}>
                {VEHICLES.map((v) => (
                  <div
                    key={v.id}
                    style={{
                      border: activeVeh===v.id ? `2px solid ${C.gold}` : `1.5px solid ${C.border}`,
                      borderRadius:18,
                      padding:"14px 10px",
                      background: activeVeh===v.id ? "#fffbea" : "#fff",
                      cursor:"pointer",
                      transition:".3s",
                      textAlign:"center",
                      boxShadow: activeVeh===v.id ? "0 10px 30px rgba(245,197,24,.18)" : "none",
                    }}
                  >
                    <img src={v.img} alt={v.label} style={{ width:"100%", maxWidth:90, height:65, objectFit:"contain", marginBottom:10 }} />
                    <div style={{ fontSize:13, fontWeight:700, color:C.dark }}>{v.label}</div>
                  </div>
                ))}
              </div>

              {/* Search Button */}
              <button
                onClick={handleFindCabs}
                style={{ width:"100%", border:"none", borderRadius:999, padding:"18px 20px", background:`linear-gradient(135deg,${C.gold},${C.goldD})`, color:C.dark, fontWeight:900, fontSize:18, cursor:"pointer", boxShadow:"0 16px 45px rgba(245,197,24,.35)" }}
              >
                Find Best Cabs →
              </button>
            </div>
            {/* ── END BOOKING CARD ── */}

          </div>
        </div>
        {/* ── END HERO ── */}

        {/* Marquee */}
        <div style={{ background:C.dark, padding:"13px 0", overflow:"hidden", borderTop:`3px solid ${C.gold}`, borderBottom:`3px solid ${C.gold}` }}>
          <div style={{ display:"flex", animation:"marquee 22s linear infinite", width:"max-content" }}>
            {doubled.map((t,i) => (
              <span key={i} style={{ padding:"0 28px", fontSize:12, fontWeight:600, color:C.gold, letterSpacing:"1px", textTransform:"uppercase", whiteSpace:"nowrap" }}>{t}</span>
            ))}
          </div>
        </div>

        {/* Stats */}
        <Section bg={C.dark}>
          <div className="stats-grid" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:28, textAlign:"center" }}>
            {STATS.map((s,i) => (
              <div key={i}>
                <div style={{ fontFamily:F.display, fontSize:"clamp(32px,5vw,56px)", fontWeight:900, color:C.gold, lineHeight:1 }}>{s.num}</div>
                <div style={{ fontSize:11, color:"rgba(255,255,255,.5)", letterSpacing:"1.5px", textTransform:"uppercase", fontWeight:600, marginTop:8 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </Section>

        {/* About Halo Sorath */}
        <Section bg="#ffffff">
          <div style={{ maxWidth:1000, margin:"0 auto", background:"#fff", borderRadius:28, padding:"40px 28px", boxShadow:"0 10px 40px rgba(0,0,0,.06)", border:`1px solid ${C.border}` }}>
            <SectionHeading
              eyebrow="Trusted Cab Booking Service in Gujarat"
              title="Halo Sorath – Reliable Taxi Service Across Gujarat"
              sub="Affordable local taxi, outstation cab, airport transfer, Gujarat tours, and comfortable travel services."
            />
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:28, marginTop:30 }}>
              <div>
                <p style={{ fontSize:15, color:C.gray, lineHeight:1.9, marginBottom:18 }}>
                  Halo Sorath provides trusted cab booking services across Gujarat. Book local taxi, outstation cab, airport transfer, Gir Somnath tour, Dwarka trip, Diu travel, and customized tour packages at affordable prices.
                </p>
                <p style={{ fontSize:15, color:C.gray, lineHeight:1.9, marginBottom:18 }}>
                  Looking for safe and affordable taxi service in Gujarat? Halo Sorath offers reliable cab booking with professional drivers for local travel, family tours, business trips, and airport pickup/drop.
                </p>
                <p style={{ fontSize:15, color:C.gray, lineHeight:1.9 }}>
                  Book comfortable taxi service with Halo Sorath for Junagadh, Gir, Somnath, Dwarka, Diu, Rajkot, Ahmedabad, and all Gujarat destinations. Fast booking and best pricing available.
                </p>
              </div>
              <div>
                <div style={{ background:"#f8f9fd", borderRadius:20, padding:"24px 22px", border:`1px solid ${C.border}`, marginBottom:20 }}>
                  <h3 style={{ fontFamily:F.display, fontSize:22, marginBottom:16, color:C.dark }}>Our Services</h3>
                  <div style={{ display:"grid", gap:12 }}>
                    {["Local taxi booking","Outstation cab service","Gujarat tour packages","Airport pickup & drop","Family & corporate travel","One-way and round-trip taxi"].map((item,i) => (
                      <div key={i} style={{ display:"flex", alignItems:"center", gap:10, fontSize:14, color:C.gray, fontWeight:600 }}>
                        <span style={{ color:C.gold }}>✔</span>{item}
                      </div>
                    ))}
                  </div>
                </div>
                <div style={{ background:C.dark, borderRadius:20, padding:"24px 22px" }}>
                  <h3 style={{ fontFamily:F.display, fontSize:22, marginBottom:16, color:C.white }}>Why Choose Us?</h3>
                  <div style={{ display:"grid", gap:12 }}>
                    {["Professional drivers","Clean and comfortable vehicles","Affordable pricing","Easy online booking","24/7 customer support"].map((item,i) => (
                      <div key={i} style={{ display:"flex", alignItems:"center", gap:10, fontSize:14, color:"rgba(255,255,255,.75)", fontWeight:600 }}>
                        <span style={{ color:C.gold }}>★</span>{item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Destinations */}
        <Section>
          <SectionHeading eyebrow="Explore Gujarat" title="Popular Destinations" sub="Tap any city to fill it as your destination instantly" />
          <div className="dest-grid" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))", gap:24 }}>
            {DESTINATIONS.map(d => (
              <div key={d.name} className="dest-card" onClick={() => navigate("/destination", { state: { destination: d } })}
                style={{ borderRadius:24, overflow:"hidden", background:C.white, boxShadow:"0 12px 35px rgba(0,0,0,.10)", cursor:"pointer", transition:"all .35s ease" }}>
                <div style={{ overflow:"hidden" }}>
                  <img src={d.img} alt={`Cab to ${d.name} – HaloSorath`} style={{ width:"100%", height:170, objectFit:"cover", transition:"transform .4s ease", display:"block" }}
                    onMouseEnter={e=>e.currentTarget.style.transform="scale(1.08)"}
                    onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"} />
                </div>
                <div style={{ padding:"18px 16px 20px" }}>
                  <h3 style={{ fontFamily:F.display, fontSize:"clamp(18px,2.5vw,22px)", fontWeight:800, marginBottom:8, color:C.dark }}>{d.name}</h3>
                  <p style={{ fontSize:13, color:C.gray, lineHeight:1.6 }}>Explore the beauty of {d.name} with comfortable and reliable cab services.</p>
                </div>
              </div>
            ))}
          </div>
        </Section>

        {/* Why Us */}
        <Section>
          <SectionHeading eyebrow="Why HaloSorath - Cab Services" title="Rides You Can Actually Trust" sub="Five reasons thousands of travellers choose us over traditional cab services." />
          <div className="why-grid" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:16 }}>
            {WHY_US.map((w,i) => (
              <div key={i} className="why-card" style={{ display:"flex", gap:16, alignItems:"flex-start", background:"#f8f9fd", borderRadius:18, padding:"20px 18px", border:`1px solid ${C.border}`, transition:"all .3s ease" }}>
                <div style={{ width:48, height:48, minWidth:48, borderRadius:13, background:"rgba(245,197,24,.1)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:22 }}>{w.icon}</div>
                <div>
                  <h4 className="why-title" style={{ fontFamily:F.display, fontSize:16, fontWeight:800, color:C.dark, marginBottom:5, transition:"color .3s" }}>{w.title}</h4>
                  <p className="why-desc" style={{ fontSize:13, color:C.grayL, lineHeight:1.65, transition:"color .3s" }}>{w.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </Section>

        {/* Fleet */}
        <Section bg="#f0f2f8">
          <SectionHeading eyebrow="Our Fleet" title="The Right Ride for Every Journey" sub="Choose from our wide range of well-maintained and comfortable vehicles." />
          <div
            ref={fleetRef}
            onMouseEnter={() => setPauseFleet(true)}
            onMouseLeave={() => setPauseFleet(false)}
            className="fleet-scroll"
            style={{ display:"flex", gap:20, overflowX:"auto", paddingBottom:12 }}
          >
            {[...FLEET, ...FLEET].map((f, i) => (
              <div key={i} className="fleet-item"
                style={{ minWidth:210, flex:"0 0 auto", background:C.white, borderRadius:20, padding:"20px 18px 16px", textAlign:"center", boxShadow:"0 6px 24px rgba(0,0,0,.07)", border:`1px solid ${C.border}`, transition:"all .3s ease" }}
                onMouseEnter={e => { e.currentTarget.style.transform="translateY(-6px)"; e.currentTarget.style.boxShadow="0 20px 50px rgba(0,0,0,.13)"; }}
                onMouseLeave={e => { e.currentTarget.style.transform="translateY(0)"; e.currentTarget.style.boxShadow="0 6px 24px rgba(0,0,0,.07)"; }}
              >
                <div style={{ background:"linear-gradient(135deg,#f8f9fd,#f0f2f8)", borderRadius:14, padding:"12px 8px", marginBottom:14 }}>
                  <img src={f.img} alt={f.name} style={{ width:"100%", height:90, objectFit:"contain" }} />
                </div>
                <h4 style={{ fontFamily:F.display, fontSize:16, fontWeight:800, color:C.dark, marginBottom:4 }}>{f.name}</h4>
                <p style={{ fontSize:12, color:C.grayL, marginBottom:10 }}>{f.seats}</p>
                <span style={{ display:"inline-block", fontSize:10, fontWeight:700, background:"rgba(245,197,24,.1)", border:"1px solid rgba(245,197,24,.3)", color:C.goldD, borderRadius:50, padding:"3px 10px" }}>{f.type}</span>
              </div>
            ))}
          </div>
        </Section>

        {/* Reviews */}
        <Section bg={C.dark}>
          <SectionHeading light eyebrow="Testimonials" title="What Our Riders Say" sub="Real journeys. Real people. Real trust built one ride at a time." />
          <div
            ref={reviewRef}
            className="fleet-scroll"
            onMouseEnter={() => setPauseReview(true)}
            onMouseLeave={() => setPauseReview(false)}
            style={{ display:"flex", gap:20, overflowX:"auto", paddingBottom:12 }}
          >
            {[...REVIEWS, ...REVIEWS].map((r, i) => (
              <div key={i} className="review-card"
                style={{ minWidth:290, maxWidth:320, flex:"0 0 auto", background:C.white, borderRadius:20, padding:"22px 20px", textAlign:"left", boxShadow:"0 6px 24px rgba(0,0,0,.12)", transition:"all .3s ease" }}
              >
                <div style={{ marginBottom:10 }}>
                  {[...Array(r.rating)].map((_,j) => <span key={j} style={{ color:C.gold, fontSize:14 }}>★</span>)}
                </div>
                <p style={{ fontSize:13, color:C.gray, lineHeight:1.75, marginBottom:18, fontStyle:"italic" }}>"{r.text}"</p>
                <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                  <div style={{ width:40, height:40, borderRadius:"50%", background:`linear-gradient(135deg,${C.gold},${C.goldD})`, display:"flex", alignItems:"center", justifyContent:"center", fontWeight:800, fontSize:16, color:C.dark, flexShrink:0 }}>
                    {r.name[0]}
                  </div>
                  <div>
                    <div style={{ fontWeight:700, fontSize:14, color:C.dark }}>{r.name}</div>
                    <div style={{ fontSize:11, color:C.grayL }}>Verified Rider ✔</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Section>

        {/* FAQ */}
        <Section bg="#f0f2f8">
          <SectionHeading eyebrow="FAQ" title="Frequently Asked Questions" sub="Got questions? We've got answers. If you need more help, just call us." />
          <div style={{ maxWidth:720, margin:"0 auto", display:"flex", flexDirection:"column", gap:12 }}>
            {FAQS.map((f,i) => (
              <div key={i} onClick={() => setOpenFaq(openFaq===i?null:i)}
                style={{ background:C.white, borderRadius:14, border:`1.5px solid ${openFaq===i?C.gold:C.border}`, overflow:"hidden", transition:"border-color .25s, box-shadow .25s", cursor:"pointer", boxShadow:openFaq===i?"0 4px 20px rgba(245,197,24,.12)":"none" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"18px 20px", gap:12 }}>
                  <span style={{ fontSize:"clamp(13px,1.6vw,15px)", fontWeight:700, color:C.dark, lineHeight:1.4 }}>{f.q}</span>
                  <span style={{ color:C.gold, fontSize:22, fontWeight:300, transition:"transform .25s", display:"inline-block", transform:openFaq===i?"rotate(45deg)":"none", flexShrink:0 }}>+</span>
                </div>
                {openFaq===i && <div style={{ padding:"14px 20px 18px", fontSize:13, color:C.gray, lineHeight:1.75, borderTop:`1px solid ${C.border}` }}>{f.a}</div>}
              </div>
            ))}
          </div>
        </Section>

        <Footer />

      </div>
    </>
  );
}